export default __webpack_public_path__ + "static/media/11_steile Passage.d627be55.png";